<template>
  <v-card v-if="project">
    <v-card-title>
      <v-avatar size=48>
        <img :src="logoThumbUrl" alt="Avatar" v-if="logoThumbUrl">
        <v-icon color="primary" large v-else>view_carousel</v-icon>
      </v-avatar>
      <span class="subheading text-uppercase pl-2">
        Create a new board
      </span>
    </v-card-title>

    <v-card-text>
      <v-form
        ref="form"
        lazy-validation
        >
        <v-text-field
          label="Title"
          name="name"
          prepend-icon=" "
          v-model="board.name"
          :maxlength="maxCharacters"
          :counter="maxCharacters"
          :rules="[rules.required]"
        ></v-text-field>

        <v-menu
          ref="menu"
          :close-on-content-click="true"
          v-model="menu"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          @click.native.stop
          :nudge-right="40"
          >
          <v-text-field slot="activator"
            v-model="board.due_on"
            label="Due on"
            prepend-icon="event"
            readonly
            clearable
          ></v-text-field>
          <v-date-picker
            color="primary"
            v-model="board.due_on"
            no-title
            scrollable
            show-current
            >
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
          </v-date-picker>
        </v-menu>

        <v-checkbox v-model="includeTicket" label="Include this ticket on the new board" v-if="ticket"></v-checkbox>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="cancel()">Cancel</v-btn>
      <v-btn color="primary" @click="saveBoard()" :loading="busy">Create Board</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'

  import boardService from '@/services/board'
  import placementService from '@/services/placement'

  export default {
    name: 'board-new',

    props: ['project', 'ticket'],

    data () {
      return {
        board: {},
        menu: false,
        includeTicket: true,
        maxCharacters: 100,
        busy: false,
        rules: {
          required: value => !!value || 'Required'
        }
      }
    },

    computed: {
      logoThumbUrl () {
        if (this.project.links && this.project.links.logo_thumb_uri) {
          return (process.env.API_URL + this.project.links.logo_thumb_uri)
        }
        return null
      }
    },

    mounted () {
    },

    methods: {
      cancel () {
        EventBus.$emit('board-created')
        this.board = {}
      },

      saveBoard () {
        this.board.project_id = this.project.id
        if (this.$refs.form.validate()) {
          this.busy = true
          boardService.projectCreate(
            (data) => {
              this.board = {}
              data.placed = this.includeTicket && this.ticket
              EventBus.$emit('board-created', data)
              if (this.includeTicket && this.ticket) {
                placementService.ticketCreate(
                  () => {
                    // nothing much to do here
                  },
                  (err) => {
                    console.log(err)
                  },
                  this.ticket.id,
                  // this is the first ticket on the new board
                  {board_id: data.id, position: 0}
                )
              }
              this.busy = false
            },
            (err) => {
              this.busy = false
              console.log(err)
            },
            this.project.id,
            this.board
          )
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/board/_new.vue